import { UserOutlined } from '@ant-design/icons';
import { Alert, Button, Drawer } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../../../../AppContext';
import useRouteDrawer from '../../../../hooks/useRouteDrawer';
import useUltraPlanSubscriber from '../../../../hooks/useUltraPlanSubscriber';
import { getSubscriberLabel } from '../../../../ultraPlanUtils';
import RoadmapPlanner from './RoadmapPlanner';

const RoadmapDrawer = ({ params, onClose, onOpenSubscriber }) => {
  const {
    state: { isDesktop },
  } = useContext(AppContext);
  const { isOpen, activeParams, getAfterOpenChange } = useRouteDrawer(params);
  const {
    subscription,
    childProfiles,
    isChildProfilesLoading,
    hasChildProfilesError,
    defaultChild,
    isSubscriptionMismatch,
  } = useUltraPlanSubscriber(activeParams || {});

  const openSubscriber = () => onOpenSubscriber(activeParams);

  return (
    <Drawer
      title={
        <div className="header-title">
          {subscription?.user
            ? `Roadmap · ${getSubscriberLabel(subscription?.user)}`
            : 'Roadmap'}
        </div>
      }
      extra={
        <Button
          icon={<UserOutlined />}
          onClick={openSubscriber}
          disabled={!activeParams}
        >
          Subscriber Details
        </Button>
      }
      open={isOpen}
      onClose={onClose}
      afterOpenChange={getAfterOpenChange()}
      width={isDesktop ? '90%' : '100%'}
      className="custom-drawer ultra-plan-drawer"
      destroyOnClose
    >
      {activeParams && (
        <>
          {isSubscriptionMismatch && (
            <Alert
              className="mb-16"
              type="warning"
              showIcon
              message="This user's current subscription differs from the one this roadmap belongs to."
            />
          )}
          <RoadmapPlanner
            key={activeParams?.userSubscriptionId}
            userSubscriptionId={activeParams?.userSubscriptionId}
            subscription={subscription}
            defaultChild={defaultChild}
            childProfiles={childProfiles}
            isChildProfilesLoading={isChildProfilesLoading}
            hasChildProfilesError={hasChildProfilesError}
            onOpenSubscriber={openSubscriber}
          />
        </>
      )}
    </Drawer>
  );
};

export default RoadmapDrawer;
